/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

// Carousel images
import { fetchImage } from '../../api/image';
import PageDataLoader from '../Utility/PageDataLoader';
import DeleteImageModal from './DeleteImageModal';
import { validatePermissionKey } from '../../helpers/permission';
import { UPDATE_CHILD } from '../Utility/PermissionKeys';

const ThumbnailGallery = ({
  images,
  canDelete,
  childId,
  fetchChildInfo,
  indexOfFirstRecord,
  gallery,
  authUser
}) => {
  const [deleteImageModal, setDeleteImageModal] = useState({
    open: false,
    executionId: null
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isGalleryZoom, setIsGalleryZoom] = useState(false);
  const [imagesLoading, setImageLoading] = useState(true);
  const [items, setItems] = useState([]);

  const fetchUrls = async () => {
    const BATCH_SIZE = 3;

    const fetchBatch = async (batch) => {
      const batchPromises = batch.map(async (i) => {
        if(!i.is_video){
        const imgUrl = await fetchImage(i.documentKey);
        if (imgUrl !== null) {
          return {
            src: imgUrl,
            altText: 'Execution img',
            caption: 'Execution img',
            executionId: i?.executionId
          };
        }
      }
      return null;
      });

      setImageLoading(true);
      const resolved = await Promise.all(batchPromises);
      setImageLoading(false);
      return resolved.filter(Boolean);
    };

    let fetchedItems = [];

    for (let i = 0; i < images.length; i += BATCH_SIZE) {
      const batch = images.slice(i, i + BATCH_SIZE);
      const batchItems = await fetchBatch(batch);
      fetchedItems = [...fetchedItems, ...batchItems];
      setItems([...fetchedItems]); // progressively set images
    }
  };

  function openDeleteImageModal(id) {
    setDeleteImageModal({ open: true, executionId: id });
  }

  function closeDeleteImageModal() {
    setDeleteImageModal({ open: false, executionId: null });
  }

  useEffect(() => {
    fetchUrls();
    // eslint-disable-next-line
  }, [images]);

  const ImagesLightbox = () => {
    return (
      <>
        {isGalleryZoom && (
          <Lightbox
            mainSrc={items[photoIndex].src}
            nextSrc={items[(photoIndex + 1) % items.length].src}
            prevSrc={items[(photoIndex + items.length - 1) % items.length].src}
            onCloseRequest={() => setIsGalleryZoom(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + items.length - 1) % items.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % items.length)
            }
          />
        )}
      </>
    );
  };

  const slides = items.map((item, index) => {
    if (item !== undefined) {
      return (
        <Col md="4" className="mb-2">
          <div className="zoom-gallery thumbnail">
            <img
              src={item.src}
              alt={item.altText}
              style={{
                width: '100%',
                height: 250
              }}
              onClick={() => {
                setIsGalleryZoom(true);
                setPhotoIndex(index);
              }}
            />
            {validatePermissionKey(authUser, UPDATE_CHILD) && canDelete && (
              <Button
                size="sm"
                color="danger"
                className="mt-1 waves-effect waves-light deleteBtn"
                onClick={() => {
                  setActiveIndex(index);
                  openDeleteImageModal(item.executionId);
                }}
              >
                <i className="ri-delete-bin-6-line align-middle"></i>
              </Button>
            )}
          </div>
        </Col>
      );
    }
  });

  return (
    <React.Fragment>
      <>
        <DeleteImageModal
          images={gallery}
          closeModalHandler={closeDeleteImageModal}
          modalOpenState={deleteImageModal.open}
          childId={childId}
          fetchChildInfo={fetchChildInfo}
          activeIndex={activeIndex}
          executionID={deleteImageModal.executionId}
        />
        <ImagesLightbox />
        <Row>
          {slides}
          <Col md="12">
            {imagesLoading && (
              <div className="text-center">
                <PageDataLoader height={40} width={40} />
              </div>
            )}
          </Col>
        </Row>
      </>
    </React.Fragment>
  );
};

export default ThumbnailGallery;
